import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { PermissionService } from '../../../services/permission.service';
import { AgencyPermission } from '../../../shared/utils/agency-rbac';

/**
 * Statut du COMPTE d'un professionnel dans « Gestion des professionnels de santé » : Validé / En attente / Désactivé.
 * Un compte en attente affiche une information ; pour qui a le droit de valider ou refuser, elle mène à « Comptes professionnels ».
 */
@Component({
  selector: 'app-pro-account-status-cell',
  standalone: true,
  imports: [NgIf],
  template: `
    <span class="acc-badge" [class.acc-active]="state === 'ACTIVE'" [class.acc-pending]="state === 'PENDING'" [class.acc-disabled]="state === 'DISABLED'">
      {{ label }}
    </span>
    <div *ngIf="state === 'PENDING'" class="acc-hint">
      <a *ngIf="canValidate; else noRight" class="acc-link" (click)="goToValidation($event)">Valider / refuser →</a>
      <ng-template #noRight><span title="Seuls les comptes habilités à valider les professionnels peuvent traiter cette demande.">En attente de l'équipe habilitée</span></ng-template>
    </div>
  `,
  styles: [`
    .acc-badge { display: inline-block; padding: 2px 10px; border-radius: 12px; font-size: 12px; font-weight: 600; white-space: nowrap; }
    .acc-active { background: #e6f6ec; color: #1e7b45; }
    .acc-pending { background: #fff4e0; color: #9a5b00; }
    .acc-disabled { background: #fdecec; color: #b42318; }
    .acc-hint { font-size: 11px; color: #6b7280; margin-top: 2px; }
    .acc-link { color: #0b3954; font-weight: 600; cursor: pointer; text-decoration: underline; }
  `],
})
export class ProAccountStatusCellComponent {
  @Input() data: any;
  @Input() column: any;

  constructor(private router: Router, private permissions: PermissionService) {}

  get state(): string {
    return this.data?.accountStatus || 'ACTIVE';
  }

  get label(): string {
    switch (this.state) {
      case 'PENDING': return 'En attente de validation';
      case 'DISABLED': return 'Désactivé';
      default: return 'Validé';
    }
  }

  get canValidate(): boolean {
    return this.permissions.has(AgencyPermission.VALIDATE_PRO_ACCOUNT);
  }

  goToValidation(event: Event): void {
    event.stopPropagation();
    this.router.navigate(['/agency/pro-accounts']);
  }
}
